// src/components/dashboard/cases/newCase/case_id/caseTable/components/CrossSectionPanel.js
import React from "react";
import {
  CLIP_PLANE_SIZE_MULT_MIN,
  CLIP_PLANE_SIZE_MULT_MAX,
} from "../constants";

const CrossSectionPanel = ({
  planeOffset,
  setPlaneOffset,
  planeSizeMult,
  setPlaneSizeMult,
  zoom2D,
  reset2DView,
  clearSection,
  clearMeasurements,
  clipEnabled,
  setClipEnabled,
  clipInverted,
  setClipInverted,
  closeCrossSection,
  clipApiRef,
}) => {
  return (
    <div className="stl-xs-panel" role="dialog" aria-label="2D cross section">
      <div className="stl-xs-header">
        <span className="stl-xs-title">2D cross section</span>
        <button
          type="button"
          className="stl-xs-close"
          onClick={closeCrossSection}
          aria-label="Close cross section"
          title="Close"
        >×</button>
      </div>

      <div className="stl-xs-settings-head">
        <span>Settings</span>
        <span className="stl-xs-collapse" aria-hidden="true">⌃</span>
      </div>

      <div className="stl-xs-row">
        <span className="stl-xs-label">
          Plane offset: {planeOffset.toFixed(2)}
        </span>
      </div>

      <div className="stl-xs-slider-wrap">
        <button
          type="button"
          className="stl-xs-arrow"
          onClick={() => setPlaneOffset((v) => Math.max(-1, +(v - 0.02).toFixed(2)))}
          aria-label="Decrease plane offset"
        >‹</button>
        <input
          type="range"
          className="stl-xs-slider"
          min={-1} max={1} step={0.01}
          value={planeOffset}
          onChange={(e) => setPlaneOffset(Number(e.target.value))}
          aria-label="Plane offset"
        />
        <button
          type="button"
          className="stl-xs-arrow"
          onClick={() => setPlaneOffset((v) => Math.min(1, +(v + 0.02).toFixed(2)))}
          aria-label="Increase plane offset"
        >›</button>
      </div>

      <div className="stl-xs-row">
        <span className="stl-xs-label">
          Circle size: {planeSizeMult.toFixed(2)}×
        </span>
      </div>

      <div className="stl-xs-slider-wrap">
        <button
          type="button"
          className="stl-xs-arrow"
          onClick={() => setPlaneSizeMult((v) =>
            Math.max(CLIP_PLANE_SIZE_MULT_MIN, +(v - 0.05).toFixed(2)))}
          aria-label="Decrease circle size"
        >‹</button>
        <input
          type="range"
          className="stl-xs-slider"
          min={CLIP_PLANE_SIZE_MULT_MIN}
          max={CLIP_PLANE_SIZE_MULT_MAX}
          step={0.01}
          value={planeSizeMult}
          onChange={(e) => setPlaneSizeMult(Number(e.target.value))}
          aria-label="Circle size"
        />
        <button
          type="button"
          className="stl-xs-arrow"
          onClick={() => setPlaneSizeMult((v) =>
            Math.min(CLIP_PLANE_SIZE_MULT_MAX, +(v + 0.05).toFixed(2)))}
          aria-label="Increase circle size"
        >›</button>
      </div>

      <div className="stl-xs-row">
        <span className="stl-xs-label">2D view zoom</span>
      </div>
      <div className="stl-xs-slider-wrap" style={{ gap: 4 }}>
        <button type="button" className="stl-xs-arrow"
          onClick={() => zoom2D(1 / 1.25)}
          aria-label="Zoom out 2D">−</button>
        <button type="button" className="stl-xs-btn" style={{ flex: 1 }}
          onClick={reset2DView}
          title="Reset 2D zoom & pan">Reset view</button>
        <button type="button" className="stl-xs-arrow"
          onClick={() => zoom2D(1.25)}
          aria-label="Zoom in 2D">+</button>
      </div>

      <div className="stl-xs-buttons-row">
        <button type="button" className="stl-xs-btn"
          onClick={clearSection}>Clear</button>
        <button type="button" className="stl-xs-btn"
          onClick={clearMeasurements}>Clear meas.</button>
        <button type="button" className="stl-xs-btn"
          onClick={() => clipApiRef.current?.recompute(0)}>Area</button>
      </div>

      <label className="stl-xs-check">
        <input type="checkbox" checked={clipEnabled}
          onChange={(e) => setClipEnabled(e.target.checked)} />
        <span>Enable clipping plane</span>
      </label>

      <label className="stl-xs-check">
        <input type="checkbox" checked={clipInverted}
          onChange={(e) => setClipInverted(e.target.checked)}
          disabled={!clipEnabled} />
        <span>Invert clipping plane</span>
      </label>

      <div className="stl-xs-actions">
        <button type="button" className="stl-xs-action ok"
          onClick={() => clipApiRef.current?.recompute(0)}>OK</button>
        <button type="button" className="stl-xs-action cancel"
          onClick={closeCrossSection}>Cancel</button>
        <button type="button" className="stl-xs-action apply"
          onClick={() => clipApiRef.current?.recompute(0)}>Apply</button>
      </div>
    </div>
  );
};

export default CrossSectionPanel;